export function formatMemberElapsedTime(milliseconds) {
  if (!Number.isSafeInteger(milliseconds)) {
    return null;
  }

  let remaining = Math.floor(Math.abs(milliseconds) / 1000) * 1000;
  const parts = [];
  for (const [unit, size] of [
    ["d", 86400000],
    ["h", 3600000],
    ["m", 60000],
  ]) {
    const value = Math.floor(remaining / size);
    if (value) {
      parts.push(`${value}${unit}`);
    }
    remaining %= size;
  }
  parts.push(`${remaining / 1000}s`);
  return `${milliseconds <= -1000 ? "-" : ""}${parts.join(" ")}`;
}

export function formatMemberElapsedTimeCompact(milliseconds) {
  if (!Number.isSafeInteger(milliseconds)) {
    return null;
  }

  const absoluteMilliseconds = Math.abs(milliseconds);
  const units = [
    ["d", 86400000],
    ["h", 3600000],
    ["m", 60000],
    ["s", 1000],
  ];
  const [unit, size] =
    units.find(([, unitSize]) => absoluteMilliseconds >= unitSize) ||
    units.at(-1);
  const value = Math.floor(absoluteMilliseconds / size);
  return `${milliseconds <= -1000 ? "-" : ""}${value}${unit}`;
}
